import { render, staticRenderFns } from "./EditRecruitingProfileVideos.vue?vue&type=template&id=14870975&scoped=true&"
import script from "./EditRecruitingProfileVideos.vue?vue&type=script&lang=ts&"
export * from "./EditRecruitingProfileVideos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14870975",
  null
  
)

export default component.exports